import React, { Component } from "react";
import { isEmpty, map, orderBy} from "lodash";
import moment from "moment-timezone";
import { DeleteOutlined } from "@ant-design/icons";
import { DatePicker, message, Modal, Popconfirm, Select, Checkbox } from "antd";
import Script from "react-load-script";
import * as yup from "yup";
import SideBar from "./SideBar";
import Loader from "../../../../../../Common/Component/Loader";
import EmptyData from "../../../../../../Common/Component/EmptyData";

import visa from "../../../../../../../Assets/images/visa_dark.svg";
import cross_icon from "../../../../../../../Assets/images/cross_icon.svg";
import AllState from "../../../../../../../Assets/data/stateList.json";
import american from "../../../../../../../Assets/images/american_express_dark.svg";

import Axios from 'axios';
const {Option} = Select;

// mapping contact method
const contact_methods = [
  {key: 'By Text', value: 'text'},
  {key: 'Call Home Phone', value: 'home_phone'},
  {key: 'Call Mobile', value: 'mobile'},
  {key: 'By Email', value: 'email'},
]

class BillingInfo extends Component {
  fattJs = null;

  constructor(props) {
    super(props);
    this.state = {
      franchises: [],
      preferred_start_date: '',
      contactMethods: [],
      display_preferred_start_date: '',
      charge_invoice_card: true,
      print_invoice_card: false,
      email_invoice: false,
      is_address_manually: false,
      isBillingAddress: true,
      address: {address: '', city: '', state: '', zip_code: ''},
      isAgreed: true,
      is_btn_active: false,
      is_basic_btn_active: false,
      errors: {},
      user_billing_info_uuid: '',
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      stax_customer_id : '',
      stax_public_apikey: '',
      hideAddNewButton: false,
      is_initial_clean: true
    }
    this.basicDetail = null;
  }

  componentDidMount = () => {
    const { customerList } = this.props;
    this.setState({ loader: true });
    this.props.getCustomerDetail(this.props.customerId) // get customer detail
    this.props.getCardList({user__uuid: this.props?.customerId});

    if (Object.keys(customerList).length > 0) {
      this.setState({ 
        stax_customer_id : customerList.customer.stax_customer,
        stax_public_apikey: customerList.customer.field_office.stax_public_apikey,
        hideAddNewButton : customerList.customer.field_office.stax_public_apikey ? false : true
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // get customer detail
    if (Object.keys(nextProps?.customerList?.customer).length > 0
      && JSON.stringify(nextProps?.customerList?.customer) !== JSON.stringify(this.state.customer)) {
      this.setState({ loader: false, customer: nextProps?.customerList?.customer, field_office_uuid: nextProps?.customerList?.customer?.field_office?.uuid });
    }

    // get franchise detail
    if (Object.keys(nextProps?.zipcodeCheck?.fieldOfficeDetail).length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.fieldOfficeDetail) !== JSON.stringify(this.state.franchises)) {
      this.setState({ loader: false, franchises: nextProps?.zipcodeCheck?.fieldOfficeDetail.data });
    }

    if (Object.keys(nextProps?.CardList?.data).length > 0
      && JSON.stringify(nextProps?.CardList?.data) !== JSON.stringify(this.state?.cardList)) {
      this.setState({loader: false, cardList: nextProps?.CardList?.data});
    }

    if (Object.keys(nextProps?.AddCard?.data).length > 0
      && JSON.stringify(nextProps?.AddCard?.data) !== JSON.stringify(this.props?.AddCard?.data)) {
      this.setState({loader: false});
      this.props.getCardList({user__uuid: this.props?.customerId})
    }

    if (this.state.hideAddNewButton) {
      message.error('Error occur while loading stax. please contact to admin.', 500);
    }
    this.setState({loader: false})
  }

  // on billing info change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on preferred date changed
  onDataChange = (e) => {
    this.setState({
      preferred_start_date: e.target.checked ? e.target.value : null,
      display_preferred_start_date: null
    })
  }

  // on billing value change
  onBillingOptionsChanged = (e, item) => {
    const { cardList } = this.state;
    const idx = cardList?.results?.findIndex(obj => obj.uuid === item.uuid);
    const value = e.target.checked;
    Object.assign(cardList.results[idx], { [e.target.name]: value })
    this.setState({ cardList, user_billing_info_uuid: cardList?.results?.[idx]?.uuid, address: cardList?.results?.[idx]?.address });
  };

  // on contact method changed
  onContactMethodChange = (e) => {
    const {contactMethods} = this.state;
    const idx = contactMethods?.indexOf(e.target.value);
    if (idx > -1) {
      contactMethods.splice(idx, 1);
    } else {
      contactMethods.push(e.target.value);
    }
    this.setState({contactMethods});
  };

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({ address: obj }, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address')
        }
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // card validation
  validate = () => {
    const {isAgreed, contactMethods, user_billing_info_uuid} = this.state;

    const schema = yup.object().shape({
      isAgreed: yup.bool().oneOf([true], 'Field must be checked'),
      // user_billing_info_uuid: yup.string().test('match', 'Card is required', (user_billing_info_uuid) => {
      //   // if (action === 'next') return user_billing_info_uuid
      //   return user_billing_info_uuid
      // }),
      // preferred_start_date: yup.string().required('Preferred start date is required'),
      contactMethods: yup.array().required('Contact method is required')
    })

    const data = {isAgreed, contactMethods};
    schema.validate(data, { abortEarly: false }).then(() => {
      this.storeInLocal()
      this.setState({errors: {}, loader: true}, () => {
        this.props.onSave()
      })
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, loader: false})
    });
  }

  // card validation
  validation = () => {
    const { address, isBillingAddress, card_number, card_expiry_month, card_expiry_year, card_cvv } = this.state;

    const cardSchema = yup.object().shape({
      card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
      card_expiry_month : yup.string().nullable().required('Card expire month is required'),
      card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
      card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
      isBillingAddress: yup.bool(),
      address: yup.object().when("isBillingAddress", {is: false, then: yup.object().shape({
        address: yup.string().required("Address is required"),
        state: yup.string().required("State is required"),
        city: yup.string().required("City is required"),
        zip_code: yup.string().required("Zipcode is required").min(5, 'Your ZIP code is invalid.')
      }) }),
    })
    const cardData = {isBillingAddress, address, card_number, card_expiry_month, card_expiry_year, card_cvv };
    cardSchema.validate(cardData, { abortEarly: false }).then(() => {
      this.storeInLocal()
      this.setState({errors: {}, loader: true}, () => {
        this.addNewCard()
      })
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data});
      message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
    });
  }
  
  // on card add
  addNewCard = () => {
    const { customer, charge_invoice_card, print_invoice_card, email_invoice, card_number, card_expiry_month, card_expiry_year } = this.state;
    // Add New Card
    const step2Data = JSON.parse(sessionStorage.getItem('step2'));
    const service_address = customer?.address?.[0];
    const billing_address = (step2Data?.address?.street_number && step2Data?.address?.route) ? {...step2Data?.address, address: `${step2Data?.address?.street_number} ${step2Data?.address?.route}`} : step2Data?.address;
    const card_address = step2Data?.isBillingAddress ? service_address : billing_address;

    if (!card_address?.geo_location) {
      delete card_address?.geo_location
    }
    
    this.setState({ loader : true });
    const token_obj = {
      address_1: card_address ? card_address.address : null,
      address_city: card_address ? card_address.city : null,
      address_state: card_address ? card_address.state : null,
      address_zip: card_address ? card_address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: customer && customer.email ? customer.email : null,
      firstname: customer && customer.first_name ? customer.first_name : null,
      lastname: customer && customer.last_name ? customer.last_name : null,
      method: 'card',
      person_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
      phone: this.state.card_phone
    }
    if (this.state.stax_customer_id) {
      token_obj['customer_id'] = this.state.stax_customer_id;
    }

    this.fattJs.tokenize(token_obj).then((res) => {
      if (res && Object.keys(res).length > 0) {
        if (!customer.billing_address[0].geo_location) {
          delete customer.billing_address[0].geo_location
        }
        this.props.addNewCard({
          user_uuid: customer ? customer.uuid : null,
          address: customer ? card_address : null,
          stax_card_token : res['id'] || null,
          card_holder_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
          charge_invoice_card: charge_invoice_card,
          print_invoice_card: print_invoice_card,
          email_invoice: email_invoice
        });
        this.setState({isAddNewCard: false}, () => 
          this.onCardClear()
        );
      }
    }).catch((err) => {
      console.error("Error : ",err);
      this.setState({ loader : false })
      map(err.fieldErrors, (item) => {
        message.error(item.message,10)
      });
      message.error(err.message,10);
    });
  }

  // store data in local
  storeInLocal = () => {
    const {
      isBillingAddress,
      address,
      stripeStatus,
      preferred_start_date,
      contactMethods,
      isAgreed,
      charge_invoice_card,
      print_invoice_card,
      email_invoice,
      user_billing_info_uuid,
      is_initial_clean
    } = this.state;
    
    sessionStorage.setItem("step2", JSON.stringify({
      isBillingAddress,
      address,
      stripeStatus,
      preferred_start_date,
      contactMethods,
      isAgreed,
      charge_invoice_card,
      print_invoice_card,
      email_invoice,
      user_billing_info_uuid,
      is_initial_clean
    }));
  }

  onCardClear = () => {
    this.setState({charge_invoice_card: false, print_invoice_card: false, email_invoice: false, errors: {}}, () => {
      console.log('card cleared...');
    });
  }

  onCancel = () => {
    this.props.onChangeView(0);
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
  }

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  // render extra footer
  renderExtraFooter = () => {
    return (
      <div className="data_indicator">
        <a href="/#" onClick={(e) => { e.preventDefault(); }} className="btn">Available</a>
        <a href="/#" onClick={(e) => { e.preventDefault(); }} className="btn unavailable">Unavailable</a>
      </div>
    )
  }

  // render existing card
  renderCardList = () => {
    const { cardList, user_billing_info_uuid } = this.state;
    return (
      <div className="card order2">
        <div className="card-title flex">
          <h5>Existing Cards</h5>
          <div>
            { cardList?.results?.length < 3 ? <button
              className="btn btn-warning"
              onClick={() => this.loadStax() }
            >Add New</button> : <span />}
          </div>
        </div>
        <div className="card-body mt-10">
          {cardList?.results?.length > 0 ?
            map(orderBy(cardList?.results, 'uuid', 'asc'), (item, index) => {
              const exp_date = `${JSON.parse(item.stax_payment_object).card_exp.toString().slice(0,2)}/${JSON.parse(item.stax_payment_object).card_exp.toString().slice(2,6)}`;

              return (
                <React.Fragment key={`card${index}`}>
                  <div className="flex ai-center mb-10" key={`card${item?.uuid}`}>
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`${item?.uuid}`}
                      name={`user_billing_info_uuid`}
                      checked={item?.uuid === user_billing_info_uuid}
                      // disabled={true}
                      onChange={(e) => this.onBillingOptionsChanged(e, item)}
                    />
                    <div className="card_img flex ai-center flex-1 ml-10">
                      {JSON.parse(item.stax_payment_object).card_type === 'visa' ?
                        <img height="25" src={visa} alt="" /> :
                        <img height="25" src={american} alt="" />} &nbsp;&nbsp;
                      <div className={'flex-1'}>
                        <div>
                          <label className="m-0">{!isEmpty(JSON.parse(item.stax_payment_object)) ? `${JSON.parse(item.stax_payment_object).card_type} ending in ${JSON.parse(item.stax_payment_object).card_last_four}` : ''}</label>
                        </div>
                        <div>
                          <label className="m-0">Exp : {exp_date}</label>
                        </div>
                      </div>
                      <Popconfirm
                        title="Are you sure?"
                        onConfirm={() => {
                          this.setState({loader: true})
                          this.props.deleteCard({uuid: item?.uuid})
                          setTimeout(() => this.props.getCardList({user__uuid: this.props?.customerId}), 1000)
                        }}
                        okText="Yes"
                        cancelText="No"
                        overlayClassName={"popup-width"}
                      >
                        <DeleteOutlined/>
                      </Popconfirm>
                    </div>
                  </div>
                </React.Fragment>
              )
            })
            : <EmptyData />
          }
        </div>
      </div>
    )
  }
  
  // render add card modal
  renderAddCardModal = () => {
    const {isAddNewCard, charge_invoice_card, print_invoice_card, email_invoice, is_address_manually, address,
      isBillingAddress, errors} = this.state;

    return (
      <Modal
        title="Add New Card"
        visible={isAddNewCard}
        onCancel={() => { this.setState({isAddNewCard: false}) }}
        footer={[
          <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => {
            this.setState({isAddNewCard: false}, () => this.onCardClear())
          }}>Cancel</button>,
          <button
            key="submit"
            className={`btn btn-warning`}
            // disabled={!emailText}
            onClick={() => this.validation()}
          >Add</button>
        ]}
      >
        <div>
          <div className={"flex mt-10"}>
            <div className={"flex-1"}>
              <div className="form-group">

                <div className="fitem">
                  <label>Card Number</label>
                  <div id="card-number" className="form--control"></div>
                </div>

                <div className="fitem">
                  <label>CVV</label>
                  <div id="card-cvv" className="form--control"></div>
                </div>

                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <label>Expiration Month</label>
                    <input type="text" className="form--control" placeholder="MM" maxLength={2} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                  </div>
                  <div className="half-fitem fitem">
                    <label>Expiration Year</label>
                    <input type="text" className="form--control" placeholder="YYYY" maxLength={4} 
                      inputMode="numeric"
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} 
                    />
                    {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 ml-30">
              <h4>Preferences</h4>
              <div className="inline-check-list sm-checks gcheck">
                <div className="fitem-check">
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    id={`charge`}
                    name={`charge_invoice_card`}
                    checked={charge_invoice_card}
                    onChange={(e) => this.onTextChange(e, 'bool')}
                  />
                  <label htmlFor={`charge`} className="fitem-ck-txt">Charge invoices to card</label>
                </div>
                <div className="fitem-check">
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    id={`printInvoice`}
                    name={`print_invoice_card`}
                    checked={print_invoice_card}
                    onChange={(e) => this.onTextChange(e, 'bool')}
                  />
                  <label htmlFor={`printInvoice`} className="fitem-ck-txt">Print invoices</label>
                </div>
                <div className="fitem-check">
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    id={`emailInvoice`}
                    name={`email_invoice`}
                    checked={email_invoice}
                    onChange={(e) => this.onTextChange(e, 'bool')}
                  />
                  <label htmlFor={`emailInvoice`} className="fitem-ck-txt">Email invoices</label>
                </div>
              </div>
            </div>
            {/*<CloseCircleOutlined className={'red'} onClick={() => this.setState({isAddNewCard: false})}/>*/}
          </div>
          <div className="fitem-check">
            <input type="checkbox" className="fitem-ck-input" id="isBillingAddress" name="isBillingAddress" checked={isBillingAddress} onChange={(e) => this.onTextChange(e, 'bool')} />
            <label htmlFor="isBillingAddress" className="fitem-ck-txt">My billing address is same as my service address</label>
          </div>
          {
            !isBillingAddress ?
              <div className="frow md-label">
                <h4>Billing Address</h4>
                <div>
                  <div className="google_search_place mb-10">
                    <Script
                      url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                      onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                    />

                    <input
                      autoComplete="off"
                      type="text"
                      ref="address"
                      className={(is_address_manually) ? 'google_search_disable form--control' : 'form--control'}
                      placeholder="Search for address"
                      name="google_address"
                      id="google_address"
                      onChange={(e) => {
                        if (!e.target.value) {
                          this.setState({
                            address: {address: '', state: '', city: '', zip_code: ''},
                          })
                        }
                      }}
                      disabled={is_address_manually}
                    />
                    <b>or <a href="/" onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        is_address_manually: true,
                        address: {address: '', state: '', city: '', zip_code: ''},
                      }, () => {
                        if (this.refs['address']) {
                          this.refs['address'].value = '';
                        }
                      })
                    }}><u>enter address manually</u></a></b>

                  </div>
                  {
                    is_address_manually &&
                    <div className="manually_address">
                      <a href="/#" onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          is_address_manually: false,
                          address: {address: '', state: '', city: '', zip_code: ''},
                        })
                      }}><img src={cross_icon} alt="" className="float-right mb-10"/></a>
                      <br/>

                      <div className="form-group mb-20">
                        <div className="fitem">
                          <input
                            type="text"
                            placeholder="Address"
                            name="address"
                            value={address?.address}
                            onChange={(e) => this.onAddressChange(e)}
                          />
                        </div>
                        <div className="half-fitem fitem">
                          <div className="half-fitem fitem">
                            <input
                              type="text"
                              placeholder="City"
                              name="city"
                              value={address?.city}
                              onChange={(e) => this.onAddressChange(e)}
                            />
                          </div>
                          <div className="half-fitem fitem">
                            <Select
                              showArrow={true}
                              name="state"
                              placeholder="State"
                              onChange={(value) => this.onAddressChange({target: {name: 'state', value: value}})}
                              value={address?.state || undefined}
                              virtual={false}
                            >
                              {this.renderAllState()}
                            </Select>
                          </div>
                          <div className="half-fitem fitem">
                            <input
                              type="text"
                              className='form--control'
                              placeholder="ZIP Code"
                              name="zip_code"
                              maxLength={5}
                              minLength={5}
                              onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                              value={address?.zip_code || ''}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zipcode'])
                  ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid address'}
                  </label> : ''}
              </div> : ''
          }
        </div>
      </Modal>
    )
  }
  
  loadStax = () => {
    this.setState({ is_edit_info: true, can_edit: false, isAddNewCard: true });    
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const FattJs = window.FattJs;
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style: "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded', handler);
      }).catch(err => {
        console.error('error occur', err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  }

  render() {
    const {onTabChange} = this.props;
    const {
      franchises,
      preferred_start_date,
      contactMethods,
      display_preferred_start_date,
      isAgreed,
      errors,
      loader,
      is_initial_clean
    } = this.state;

    return (
      <div className="container">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <div style={{"padding": "30px"}}>
              <span className={"secondary-link"} onClick={() => onTabChange(0)}>Back to Service Information</span>
              <h3 style={{marginTop: "10px"}}>Contact Information</h3>
              <div className="form-block">
                <div
                  className="frow md-label"
                  style={{'display': 'flex', 'justifyContent': 'space-between', 'alignItems': 'center'}}
                >
                  <h4>{is_initial_clean ? 'Preferred Start Date' : 'Select a Date'}</h4>
                  <Checkbox
                    checked={is_initial_clean}
                    onChange={(e) => {
                      this.setState({is_initial_clean: e.target.checked})
                      this.props.priceCalc({is_initial_clean: e.target.checked})
                    }
                    }
                  >
                    Initial cleaning service
                  </Checkbox>
                </div>
                <div>
                  <div className="oplist">
                    {/*render date list*/}
                    { is_initial_clean ? map(franchises?.sort()?.slice(0, 3), (item, i) => {
                      let isSelected = preferred_start_date === item
                      return (
                        <div className="inline-checks" key={`preferred_start_dates${i}`}>
                          <label htmlFor={item} className={isSelected ? 'active' : ''}>
                            <input type="radio" id={item} name="preferred_start_date" checked={isSelected} value={item} className="" onChange={(e) => { this.onDataChange(e) }}/>
                            <span>{moment(item, "MM-DD-YYYY").format('ddd, MMM DD')}</span>
                          </label>
                        </div>
                      )}) : null}
                    <div className="inline-checks">
                      <DatePicker
                        renderExtraFooter={() => this.renderExtraFooter()}
                        inputReadOnly
                        mode={'date'}
                        className={display_preferred_start_date ? 'active' : 'box_opacity'}
                        placeholder={is_initial_clean ? 'Select another date' : 'Select date'}
                        format={"ddd, MMM DD"}
                        value={display_preferred_start_date}
                        onChange={(e) => {
                          this.setState({
                            display_preferred_start_date: e,
                            preferred_start_date: moment(e).format('MM-DD-YYYY')
                          });
                        }}
                        disabledDate={current => {
                          // const dateData = get(franchises, `['preferred_start_dates']`, []);
                          return !franchises?.sort()?.slice(3, franchises.length).includes(moment(current).format('MM-DD-YYYY'))
                        }}
                      />
                    </div>
                    {errors?.['preferred_start_date'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['preferred_start_date']}</label> : ''}
                  </div>
                </div>
                <div className="frow md-label">
                  <h4>Preferred Contact Method</h4>
                  <div className="oplist">
                    {map(contact_methods, (item, index) => {
                      const isInclude = contactMethods?.includes(item?.value);
                      return (
                        <div className="inline-checks" key={`contactMethod${index}`}>
                          <label htmlFor={item?.value} className={isInclude ? 'active' : ''}>
                            <input type="checkbox" id={item?.value} name='contactMethod' className="" value={item?.value} onChange={(e) => this.onContactMethodChange(e)}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['contactMethods'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['contactMethods']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>Payment Information</h4>
                  <span>Accounts are charged the beginning of each month for service provided the prior month.</span>
                  {this.renderCardList()}
                  {errors?.['user_billing_info_uuid'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['user_billing_info_uuid']}</label> : ''}
                </div>
                <hr/>
                <div className="frow md-label">
                  <h4> Terms of Service</h4>
                  {/*TODO: Add or delete Terms of Service link */}
                  <span>By signing up, I grant my permission for DoodyCalls to access my property and agree to the<br /> full DoodyCalls <a href="/#">Terms of Service</a> and <a href="https://www.doodycalls.com/privacy-policy/">Privacy Policy.</a></span>
                  <div className="fitem-check mt-10">
                    <input type="checkbox" className="fitem-ck-input" id="isAgreed" name="isAgreed" checked={isAgreed} onChange={(e) => this.onTextChange(e, 'bool')} />
                    <label htmlFor="isAgreed" className="fitem-ck-txt">Customer verbally agreed</label>
                  </div>
                  {errors?.['isAgreed'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['isAgreed']}</label> : ''}
                </div>
              </div>
            </div>
          </div>
          <SideBar
            coupon_code={this.state.coupon_code}
            // reducers
            PricingCalc={this.props.PricingCalc}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            priceCalc={this.props.priceCalc}
            currentTab={this.props.currentTab}
          />
        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          <button className={`btn btn-warning`} onClick={() => this.validate()}>Save</button>
        </div>
        {this.renderAddCardModal()}
      </div>
    )
  }
}

export default BillingInfo;